import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, lazy } from "react";
import { useIntl } from "react-intl";
import mapValues from "lodash/mapValues";
import { useMediaQuery, useTheme, Typography } from "@material-ui/core";
import { ListCell } from "./ListCell";
import { tableIcons } from "./tableIcons";
import { messages } from "./messages";
import { getNumberEdit, getDateEdit, getDateTimeEdit, getTimeEdit, TextEdit } from "./cellEditors";
import { getNumberRenderer, getDateRenderer, getTimeRenderer } from "./cellRenderers";
const MaterialTable = lazy(() => import(/* webpackChunkName: "material-table"  */ "@material-table/core"));
const mapToFormattedMessage = (intl, obj) => mapValues(obj, m => intl.formatMessage(m));
function fromDployColumn(column) {
    switch (column.type) {
        case "numeric":
            return {
                render: getNumberRenderer(column),
                editComponent: getNumberEdit(column),
                ...column,
                type: column.type
            };
        case "currency":
            return {
                render: getNumberRenderer(column, "currency"),
                editComponent: getNumberEdit(column, "currency_input"),
                ...column,
                type: column.type
            };
        case "percent":
        case "percentFraction":
            return {
                render: getNumberRenderer(column, "percent"),
                editComponent: getNumberEdit(column, "percent_input"),
                ...column,
                type: "numeric"
            };
        case "date":
            return {
                render: getDateRenderer(column),
                editComponent: getDateEdit(column),
                ...column,
                type: column.type
            };
        case "datetime":
            return {
                render: getDateRenderer(column, "long_datetime"),
                editComponent: getDateTimeEdit(column, "long_datetime"),
                ...column,
                type: column.type
            };
        case "datenumeric":
            return {
                render: getDateRenderer(column, "short_numeric"),
                editComponent: getDateTimeEdit(column, "short_numeric"),
                ...column,
                type: "date"
            };
        case "time":
            return {
                render: getTimeRenderer(column),
                editComponent: getTimeEdit(column),
                ...column,
                type: column.type
            };
        case "boolean":
            return column;
        case "string":
            return {
                editComponent: TextEdit,
                ...column,
                type: undefined,
                cellStyle: { whiteSpace: "pre-wrap", ...column.cellStyle }
            };
        default:
            return {
                editComponent: TextEdit,
                ...column,
                type: column.type
            };
    }
}
function DployTable(props) {
    const { listCellsBreakpoint = 0, ...rest } = props;
    const icons = useMemo(() => ({
        ...tableIcons,
        ...props.icons
    }), [props.icons]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down(listCellsBreakpoint));
    const options = useMemo(() => isMobile
        ? {
            ...props.options,
            header: false
        }
        : props.options, [isMobile, props.options]);
    let columns = useMemo(() => props.columns.map(fromDployColumn), [props.columns]);
    columns = useMemo(() => {
        if (isMobile) {
            return [
                {
                    field: "mobileField",
                    title: "mobil",
                    render: rowData => (_jsx(ListCell, { rowData: rowData, columns: columns.filter(x => !x.hidden) }))
                }
            ];
        }
        return columns;
    }, [isMobile, columns]);
    const intl = useIntl();
    const localization = useMemo(() => {
        return {
            grouping: {
                ...mapToFormattedMessage(intl, messages.grouping),
                ...props.localization?.grouping
            },
            pagination: {
                ...mapToFormattedMessage(intl, messages.pagination),
                ...props.localization?.pagination
            },
            toolbar: {
                ...mapToFormattedMessage(intl, messages.toolbar),
                ...props.localization?.toolbar
            },
            header: {
                ...mapToFormattedMessage(intl, messages.header),
                ...props.localization?.header
            },
            body: {
                ...mapToFormattedMessage(intl, messages.body),
                ...props.localization?.body,
                filterRow: {
                    ...mapToFormattedMessage(intl, messages.bodyFilterRow),
                    ...props.localization?.body?.filterRow
                },
                editRow: {
                    ...mapToFormattedMessage(intl, messages.bodyEditRow),
                    ...props.localization?.body?.editRow
                }
            }
        };
    }, [intl, props.localization]);
    const components = useMemo(() => ({
        Container: ({ children }) => children,
        ...props.components
    }), [props.components]);
    // const data = useMemo(
    // 	() =>
    // 		props.data && typeof (props.data as any).map === "function"
    // 			? (props.data as any).map(d => ({ ...d }))
    // 			: props.data,
    // 	[props.data]
    // );
    const title = useMemo(() => typeof props.title === "string" ? (_jsx(Typography, { variant: "h6", style: { margin: 11, marginLeft: 0 }, children: props.title })) : (props.title), [props.title]);
    return (_jsx(MaterialTable, { ...rest, title: title, options: options, columns: columns, components: components, localization: localization, icons: icons }));
}
DployTable.displayName = "DployTable";
export { DployTable };
//# sourceMappingURL=DployTable.js.map